/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_BtnInputs */

const en_cancel_btn = /** @type {(inputs: Cancel_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const ar_cancel_btn = /** @type {(inputs: Cancel_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إلغاء`)
};

const de_cancel_btn = /** @type {(inputs: Cancel_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbrechen`)
};

const es_cancel_btn = /** @type {(inputs: Cancel_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const fr_cancel_btn = /** @type {(inputs: Cancel_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const it_cancel_btn = /** @type {(inputs: Cancel_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulla`)
};

const ja_cancel_btn = /** @type {(inputs: Cancel_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセル`)
};

const ko_cancel_btn = /** @type {(inputs: Cancel_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`취소`)
};

const pt_br_cancel_btn = /** @type {(inputs: Cancel_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const ru_cancel_btn = /** @type {(inputs: Cancel_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена`)
};

const th_cancel_btn = /** @type {(inputs: Cancel_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยกเลิก`)
};

const tr_cancel_btn = /** @type {(inputs: Cancel_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İptal`)
};

const zh_cn_cancel_btn = /** @type {(inputs: Cancel_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消`)
};

const zh_tw_cancel_btn = /** @type {(inputs: Cancel_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Cancel_BtnInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const cancel_btn = /** @type {((inputs?: Cancel_BtnInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_BtnInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cancel_btn(inputs)
	if (locale === "ar") return ar_cancel_btn(inputs)
	if (locale === "de") return de_cancel_btn(inputs)
	if (locale === "es") return es_cancel_btn(inputs)
	if (locale === "fr") return fr_cancel_btn(inputs)
	if (locale === "it") return it_cancel_btn(inputs)
	if (locale === "ja") return ja_cancel_btn(inputs)
	if (locale === "ko") return ko_cancel_btn(inputs)
	if (locale === "pt_br") return pt_br_cancel_btn(inputs)
	if (locale === "ru") return ru_cancel_btn(inputs)
	if (locale === "th") return th_cancel_btn(inputs)
	if (locale === "tr") return tr_cancel_btn(inputs)
	if (locale === "zh_cn") return zh_cn_cancel_btn(inputs)
	return zh_tw_cancel_btn(inputs)
});